module.exports = __webpack_public_path__ + "img/programme2.0c80491c.png";